import React, { useEffect, useState } from "react";
import "./RightSidebar.css";

const RightSidebar = () => {
  const [topSchemes, setTopSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopSchemes = async () => {
      try {
        setLoading(true);
  
        const response = await fetch(
          "https://api-sales-insights.haqdarshak.com/top-schemes-benefit-value",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}) // send empty filters for now
          }
        );
  
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
  
        const data = await response.json();
        setTopSchemes(data);
  
      } catch (err) {
        console.error("Error fetching top schemes:", err);
        setError("Unable to load top schemes");
      } finally {
        setLoading(false);
      }
    };
  
    fetchTopSchemes();
  }, []);

  return (
    <div className="rightsidebar">
      <h3>Top 10 Schemes Delivered</h3>
      <p className="location">All India</p>

      <div className="content">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : topSchemes.length === 0 ? (
          <p>No schemes available</p>
        ) : (
          topSchemes.map((scheme, index) => (
            <div key={index} className="card">
              <h4>{scheme.Parent_Scheme_Name}</h4>

              <div className="info">
                <div className="info-item">
                  <span className="info-label">Benefit Received : </span>
                  <span> {Number(scheme.Total_BR || 0).toLocaleString()}</span>
                </div>

                <div className="info-item">
                  <span className="info-label1">
                    Application Opened : 
                  </span>
                  <span>{Number(scheme.Total_OpenCount || 0).toLocaleString()}</span>
                </div>

                <div className="info-item">
                  <span className="info-label1">
                    Benefit Value :
                  </span>
                  <span>
                    ₹ {Number(scheme.Total_Benefit_Value).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RightSidebar;